const credentials = {
  NAME: "StockAnts",
  PREMIUM_COST_THIRTY_DAYS: 499,
  PREMIUM_COST_SEVEN_DAYS: 299,
};

const cashfreeCredentials = {
  // // production
  // appId: "6606400047c89d050193ee9c1f046066",

  // // // test
  appId: "TEST10164173d555677b76ba1de4d1b037146101",
};

const fcmCredentials = {
  apiKey: "AIzaSyCn8I33rNj3tmxWQYXwX6iJGk7NxixIxHU",
  authDomain: "stockants-1563343458515.firebaseapp.com",
  databaseURL: "https://stockants-1563343458515.firebaseio.com",
  projectId: "stockants-1563343458515",
  storageBucket: "stockants-1563343458515.appspot.com",
  messagingSenderId: "1091584009811",
  appId: "1:1091584009811:web:4120f0b837d4a7fe5988a6",
  measurementId: "G-59K8JG9PE1",
  vapidKey: "BInW6BvJVtlFYcJv5gYj5Mlo1VPHmNIyF93a9kvsVeoIt98VOX_WbU3UkWPPZ4qCsgHb2wYrRqlSRypOJjDOdyM"
}

// const AWS_CONFIG = {
//   accessKeyId: "AKIAZH4VSHSYMLCXJ25N", 
//   secretAccessKey: "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",
//   region: "ap-south-1",
//   bucket: "",
//   // bucket: "prodsng/chat/12"
// };

exports.cashfreeCredentials = cashfreeCredentials;

exports.credentials = credentials;

exports.fcmCredentials = fcmCredentials;

// exports.AWS_CONFIG = AWS_CONFIG;